/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Letterpreviewopencta3Inputs */

const en_letterpreviewopencta3 = /** @type {(inputs: Letterpreviewopencta3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview & download my letter →`)
};

const pt_letterpreviewopencta3 = /** @type {(inputs: Letterpreviewopencta3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pré-visualizar e descarregar carta →`)
};

/**
* | output |
* | --- |
* | "Preview & download my letter →" |
*
* @param {Letterpreviewopencta3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const letterpreviewopencta3 = /** @type {((inputs?: Letterpreviewopencta3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Letterpreviewopencta3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_letterpreviewopencta3(inputs)
	return pt_letterpreviewopencta3(inputs)
});
export { letterpreviewopencta3 as "letterPreviewOpenCta" }